// ** Reducers Imports
import { combineReducers } from 'redux'
import layout from './layout'
import navbar from './navbar'
import autenticacao from './autenticacao'
import empresa from './empresa'
import segmentos from './segmentos'
import setores from './setor'
import tour from './tour'
import pontoembarque from './pontoembarque'
import controlevoucherestoque from './controlevoucherestoque'
import pontoembarquegrupo from './pontoembarquegrupo'
import solicitacaovoucher from './solicitacaovoucher'
import funcao from './funcao'
import funcionario from './funcionario'
import parceiro from './parceiro'
import atividades from './atividades'
import usuario from './usuario'
import mundo from './mundo'
import home from './home'
import banco from './banco'
import produto from './produto'
import diaria from './diaria'
import diariaCategoria from './diariaCategoria'
import permicao from './permicao'
import tarifario from './tarifario'
import cambio from './cambio'
import motorista from './motorista'
import motivobloqueio from './motivobloqueio'
import motivoPontoEmbarque from './motivoPontoEmbarque'
import veiculo from './veiculo'
import bloqueioembarque from './bloqueioembarque'
import taxaentrada from './taxaentrada'
import descontoreserva from './descontoreserva'
import motivodesistencia from './motivodesistencia'
import grupomotivosdesistencia from './grupomotivodesistencia'
import veiculomodelo from './veiculomodelo'
import empresamaquina from './empresamaquina'
import maquina from './maquina'
import multa from './multa'
import conta from './conta'
import contaPagar from './contaPagar'
import contaReceber from './contaReceber'
import reserva from './reserva'
import configuracaoReservaVoucher from './configuracaoReservaVoucher'
import atividadefornecedor from './atividadefornecedor'
import tarifarioCategoria from './tarifarioCategoria'
import motivo from './motivo'
import motivoCategoria from './motivoCategoria'
import reservaMotivo from './reservaMotivo'
import pagamentoForma from './pagamentoForma'
import acertoFinanceiros from './acertoFinanceiros'
import formaRecebimento from './formaRecebimento'
import fatura from './fatura'
import fontePagamento from './fontePagamento'
import faturaFornecedor from './faturaFornecedor'
import dre from './dre'
import caixaFluxo from './caixaFluxo'
import acertoFinanceiroAnalise from './acertoFinanceiroAnalise'
import hierarquia from './hierarquia'
import pontoembarquetipo from './pontoembarquetipo'
import adminLog from './adminLog'
import pontoembarquerota from './pontoembarquerota'
import parceiroPerfil from './parceiroPerfil'
import agentes from './agentes'
import comercial from './comercial'
import endereco from './endereco'

const rootReducer = combineReducers({
    navbar,
    layout,
    atividades,
    autenticacao,
    empresa,
    segmentos,
    setores,
    tour,
    pontoembarque,
    controlevoucherestoque,
    pontoembarquegrupo,
    solicitacaovoucher,
    funcionario,
    usuario,
    funcao,
    mundo,
    parceiro,
    banco,
    produto,
    motorista,
    cambio,
    produto,
    tarifario,
    motivobloqueio,
    diaria,
    diariaCategoria,
    permicao, 
    motivoPontoEmbarque,
    veiculo,
    bloqueioembarque,
    veiculomodelo,
    multa,
    taxaentrada,
    descontoreserva,
    motivodesistencia,
    grupomotivosdesistencia,
    veiculomodelo,
    empresamaquina,
    maquina,
    conta,
    contaPagar,
    contaReceber,
    reserva,
    configuracaoReservaVoucher,
    atividadefornecedor,
    tarifarioCategoria,
    motivo,
    motivoCategoria,
    reservaMotivo,
    pagamentoForma,
    acertoFinanceiros,
    formaRecebimento,
    fatura,
    fontePagamento,
    faturaFornecedor,
    home,
    dre,
    caixaFluxo,
    acertoFinanceiroAnalise,
    pontoembarquetipo,
    hierarquia,
    adminLog,
    pontoembarquerota,
    parceiroPerfil,
    agentes,
    comercial,
    endereco,
})

export default rootReducer